import studyTabConfig from '@/assets/components_config/studyTabConfig';
import helpLinksConfig from '@/assets/components_config/helpLinksConfig';

export default {
	// called by Vue.use(Configs)
	install (Vue, options) {
		// Configuration properties that can be accessed globally
		Object.defineProperty(Vue.prototype, '$studyTabConfig', { value: studyTabConfig });
		Object.defineProperty(Vue.prototype, '$helpLinksConfig', { value: helpLinksConfig });
	}
}
